import { Component, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { SponsorPerson } from '../../../api/app-types/sponsor.app';
import { LvrSimplePanel } from '../../../core/components/simple-panel/simple-panel';

@Component({
	selector: 'lvr-sponsor-persons-item',
	imports: [TranslocoPipe, LvrSimplePanel],
	templateUrl: './sponsor-persons-item.html',
	styleUrl: './sponsor-persons-item.scss',
})
export class SponsorPersonsItem {
	public readonly person = input<SponsorPerson>();
	public readonly sponsorName = input<string>('');
}
